import addedToCartObjectIDsAfterSearch from './addedToCartObjectIDsAfterSearch';
import addedToCartObjectIDs from './addedToCartObjectIDs';
import getQueryIdFromUrl from '../../../utils/getQueryIdFromUrl';

const handleAddToCartInsight = productCode => {
	const queryIDFromUrl = getQueryIdFromUrl();
	const queryIDFromHit = document
		.querySelector('.product-lister-item')
		?.getAttribute('data-query-id');
	const queryID = queryIDFromUrl ?? queryIDFromHit;

	if (queryID) {
		addedToCartObjectIDsAfterSearch(queryID, productCode);
	} else {
		addedToCartObjectIDs(productCode);
	}
};

const addToCartSubscribe = () => {
	window?.od?.events?.subscribe('addToCart_Submitting', data => {
		window?.od?.events?.subscribe('addToCart_Submitted', () =>
			handleAddToCartInsight(data?.productCode),
		);
	});
};

export default addToCartSubscribe;
